import { usePageTitle } from '../hooks/usePageTitle';
import React, { useEffect, useState } from 'react';
import api from '../api';
import { useTheme } from '../contexts/ThemeContext';

const Salonlar: React.FC = () => {
  usePageTitle('Salonlar');
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const cardHover   = isDark ? '#252525' : '#fafafa';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const borderSub   = isDark ? '#202020' : '#f0f0f0';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';
  const [salonlar, setSalonlar] = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(false);
  const [duzenle, setDuzenle] = useState<any>(null);
  const [form, setForm] = useState({ ad: '', kapasite: 20, konum: '', aciklama: '' });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  const yukle = () => {
    setYukleniyor(true);
    api.get('/api/salonlar')
      .then(res => setSalonlar(res.data))
      .finally(() => setYukleniyor(false));
  };

  useEffect(() => { yukle(); }, []);

  const ac = (salon?: any) => {
    if (salon) {
      setDuzenle(salon);
      setForm({ ad: salon.ad, kapasite: salon.kapasite, konum: salon.konum || '', aciklama: salon.aciklama || '' });
    } else {
      setDuzenle(null);
      setForm({ ad: '', kapasite: 20, konum: '', aciklama: '' });
    }
    setHata('');
    setModal(true);
  };

  const kaydet = async () => {
    if (!form.ad) { setHata('Salon adı zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      if (duzenle) await api.put(`/api/salonlar/${duzenle.id}`, form);
      else await api.post('/api/salonlar', form);
      setModal(false);
      yukle();
    } catch (err: any) {
      setHata(err.response?.data?.hata || 'Hata oluştu');
    } finally { setKaydediliyor(false); }
  };

  const sil = async (id: string) => {
    if (!window.confirm('Bu salonu silmek istediğinize emin misiniz?')) return;
    try {
      await api.delete(`/api/salonlar/${id}`);
      yukle();
    } catch (err: any) {
      alert(err.response?.data?.hata || 'Silinemedi');
    }
  };

  const RENKLER = [
    { bg: '#EEEDFE', text: '#3C3489' },
    { bg: '#E1F5EE', text: '#085041' },
    { bg: '#FBEAF0', text: '#72243E' },
    { bg: '#FAEEDA', text: '#854F0B' },
    { bg: '#E6F1FB', text: '#0C447C' },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>Salonlar</h1>
        <button onClick={() => ac()} style={{ background: '#534AB7', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
          + Salon ekle
        </button>
      </div>

      {yukleniyor ? (
        <div style={{ textAlign: 'center', color: textSec, padding: 40 }}>Yükleniyor...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
          {salonlar.map((s, i) => {
            const renk = RENKLER[i % RENKLER.length];
            return (
              <div key={s.id} style={{ background: card, border: `1px solid ${border}`, borderRadius: 10, padding: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 8, background: renk.bg, color: renk.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 600 }}>
                    {s.ad.charAt(0)}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{s.ad}</div>
                    <div style={{ fontSize: 11, color: textMuted }}>Max {s.kapasite} kişi{s.konum ? ` · ${s.konum}` : ''}</div>
                  </div>
                </div>
                {s.aciklama && <div style={{ fontSize: 12, color: textSec, marginBottom: 10 }}>{s.aciklama}</div>}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ background: isDark ? '#222222' : '#f0f0f0', color: isDark ? '#999' : '#666', borderRadius: 20, padding: '2px 8px', fontSize: 11 }}>
                    {s.ders_sayisi} ders atanmış
                  </span>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => ac(s)} style={{ border: `1px solid ${border}`, background: card, padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>Düzenle</button>
                    <button onClick={() => sil(s.id)} style={{ border: '1px solid #fee', background: '#fff5f5', color: '#e24b4a', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11 }}>Sil</button>
                  </div>
                </div>
              </div>
            );
          })}
          {salonlar.length === 0 && (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 40, color: textMuted, background: card, borderRadius: 10, border: '1px dashed #ddd' }}>
              Henüz salon eklenmedi. "+ Salon ekle" butonuna tıklayın.
            </div>
          )}
        </div>
      )}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}
          onClick={e => { if (e.target === e.currentTarget) setModal(false); }}>
          <div style={{ background: card, borderRadius: 12, padding: 24, width: 400 }}>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 16 }}>{duzenle ? 'Salonu düzenle' : 'Yeni salon ekle'}</div>

            {[
              { label: 'Salon adı', key: 'ad', placeholder: 'Örn: Ana Salon' },
              { label: 'Kat / konum (opsiyonel)', key: 'konum', placeholder: 'Örn: 1. kat' },
              { label: 'Açıklama (opsiyonel)', key: 'aciklama', placeholder: 'Örn: Aynalı zemin, ses sistemi' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 11, color: textSec, marginBottom: 4, fontWeight: 500 }}>{f.label}</div>
                <input value={(form as any)[f.key]} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
                  placeholder={f.placeholder}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
            ))}

            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 11, color: textSec, marginBottom: 4, fontWeight: 500 }}>Kapasite (max kişi)</div>
              <input type="number" value={form.kapasite} onChange={e => setForm(p => ({ ...p, kapasite: parseInt(e.target.value) || 20 }))}
                style={{ width: 100, padding: '8px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }} />
            </div>

            {hata && <div style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color: '#A32D2D', padding: '8px 12px', borderRadius: 6, fontSize: 12, marginBottom: 10 }}>{hata}</div>}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
              <button onClick={() => setModal(false)} style={{ padding: '8px 16px', borderRadius: 6, border: `1px solid ${border}`, background: card, cursor: 'pointer', fontSize: 13 }}>İptal</button>
              <button onClick={kaydet} disabled={kaydediliyor}
                style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: '#534AB7', color: 'white', cursor: 'pointer', fontSize: 13 }}>
                {kaydediliyor ? 'Kaydediliyor...' : duzenle ? 'Güncelle' : 'Ekle'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Salonlar;
